import { render, staticRenderFns } from "./LegacyTextBlock.vue?vue&type=template&id=0886604d"
import script from "./LegacyTextBlock.vue?vue&type=script&lang=ts"
export * from "./LegacyTextBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports